import { Alert, AlertTitle, Box, Stack, Typography } from '@mui/material'
import type { ReactNode } from 'react'
import React from 'react'
import { useIntl } from 'react-intl'
import type { DrawerViewProps } from '../DrawerView'
import DrawerView from '../DrawerView'

type DrawerViewShareWithAllInfoProps = Omit<DrawerViewProps, 'title'>

const DrawerViewShareWithAllInfo: React.FC<DrawerViewShareWithAllInfoProps> = ({ ...props }) => {
  const { formatMessage } = useIntl()

  return (
    <DrawerView title={formatMessage({ id: 'general.learnMore' })} {...props}>
      <Box sx={{ p: 3, gap: 4, display: 'flex', flexDirection: 'column' }}>
        <Stack spacing={2}>
          <Typography variant="subtitle1">
            {formatMessage({ id: 'reporting.sharing.information.shareWithWfTitle' })}
          </Typography>
          <Typography paragraph>{formatMessage({ id: 'reporting.sharing.information.shareWithWfBody' })}</Typography>
        </Stack>

        <Stack spacing={2}>
          <Typography variant="subtitle1">
            {formatMessage({ id: 'reporting.sharing.information.whatIsTitle' })}
          </Typography>
          <Typography paragraph>{formatMessage({ id: 'reporting.sharing.information.whatIsBody' })}</Typography>
        </Stack>

        <Stack spacing={2}>
          <Typography variant="subtitle1">
            {formatMessage({ id: 'reporting.sharing.information.contributeToGreaterTransparencyTitle' })}
          </Typography>
          <Typography paragraph>
            {formatMessage({ id: 'reporting.sharing.information.contributeToGreaterTransparencyBody' })}
          </Typography>
        </Stack>

        <Alert severity="info" sx={{ alignItems: 'flex-start' }}>
          <Stack spacing={2}>
            <AlertTitle>{formatMessage({ id: 'reporting.sharing.information.importantToKnowTitle' })}</AlertTitle>
            <Typography variant="body2" color="text.primary">
              {formatMessage({ id: 'reporting.sharing.information.importantToKnowBodyPartOne' })}
            </Typography>
            <Typography variant="body2" color="text.primary">
              {formatMessage(
                { id: 'reporting.sharing.information.importantToKnowBodyPartTwo' },
                {
                  strong: (chunks: ReactNode) => <strong>{chunks}</strong>,
                },
              )}
            </Typography>
          </Stack>
        </Alert>
      </Box>
    </DrawerView>
  )
}

export default DrawerViewShareWithAllInfo
